import styled from 'styled-components';
export const formSelectCustomStyle = height => ({
  valueContainer: (base, {
    isDisabled
  }) => ({
    ...base,
    width: '100%',
    padding: '0',
    fontSize: '.875rem',
    fontWeight: '500',
    background: isDisabled ? 'var(--gray-95)' : '',
    display: 'flex',
    height: '100%',
    flexWrap: 'nowrap'
  }),
  singleValue: (base, {
    isDisabled
  }) => ({
    ...base,
    color: isDisabled ? 'var(--gray-50)' : ''
  }),
  indicatorsContainer: (base, {
    isDisabled
  }) => ({
    ...base,
    background: isDisabled ? 'var(--gray-95)' : ''
  }),
  dropdownIndicator: base => ({
    ...base,
    padding: '0',
    cursor: 'pointer',
    color: 'var(--gray-10)',
    '&:hover': {
      color: 'var(--gray-10)'
    }
  }),
  indicatorSeparator: base => ({
    ...base,
    display: 'none'
  }),
  container: base => ({
    ...base,
    height: height ?? '3rem',
    width: '100%'
  }),
  menu: base => ({
    ...base,
    fontSize: '.875rem',
    zIndex: 10
  }),
  menuList: base => ({
    ...base,
    borderRadius: '0.5rem',
    paddingLeft: '0.25rem',
    paddingRight: '0.25rem'
  }),
  control: (base, state) => ({
    ...base,
    height: height ?? '3rem',
    boxSizing: 'border-box',
    overflow: 'hidden',
    borderRadius: '0.5rem',
    borderColor: state.isFocused ? 'var(--blue-50)' : 'var(--gray-70)',
    borderWidth: state.isFocused ? '2px' : '1px',
    padding: state.isFocused ? '0 calc(1rem - 1px) !important' : '1px 1rem !important',
    boxShadow: 'none',
    transition: 'none',
    '&:hover': {
      borderColor: ''
    },
    '&:focus': {
      borderColor: ''
    }
  }),
  input: (base, {
    isDisabled
  }) => ({
    ...base,
    height: 'fit-content',
    padding: 0,
    margin: 0,
    color: isDisabled ? 'var(--gray-50)' : ''
  }),
  placeholder: base => ({
    ...base,
    fontSize: '.875rem',
    color: 'var(--gray-60)',
    lineHeight: '1.25rem'
  }),
  option: () => ({})
});
export const FormRadioStyle = styled.div.withConfig({
  componentId: "sc-e8u0ic-0"
})(["&{", " div.radio-wrap{", " flex-direction:", ";width:", ";min-height:3rem;grid-template-columns:", ";> label{flex:1 1 auto;input[type='radio']{display:none;}input[type='radio']:checked + span{", "}input[type='radio'][disabled]:checked + span{", "}input[type='radio'][disabled] + span{", "}> span{", ";border-radius:1.5rem;background:white;}}}div.long-radio{", " flex:1;> label{", " > input{display:none;:checked ~ span{", " > svg{display:flex;margin-right:0.25rem;}}}> span{display:flex;align-items:center;padding:0.75rem 1rem;width:100%;border:1px solid var(--gray-70);border-radius:0.5rem;cursor:pointer;> svg{display:none;margin-right:0.25rem;}}}}div.normal-radio{", " flex-grow:0;flex-direction:", ";gap:", ";> label{", " flex-grow:", ";> input[type='radio']{display:block;margin-right:0.25rem;:checked ~ span{", " border:none;}:disabled ~ span{", "}}> span{", " border:none;}}}div.square-radio{", " min-height:2.5rem;grid-template-columns:", ";> label{width:100%;input[type='radio']{display:none;}input[type='radio']:checked + span{", "}input[type='radio'][disabled]:checked + span{", "}input[type='radio'][disabled] + span{", "}> span{", ";border-radius:0.5rem;background:white;}}}div.big-square-radio{", " grid-template-columns:", ";> label{width:100%;input[type='radio']{display:none;}input[type='radio']:checked + span{", "}input[type='radio'][disabled]:checked + span{", "}input[type='radio'][disabled] + span{", "}> span{", ";border-radius:0.5rem;background:white;}}}}"], {
  "width": "100%"
}, {
  "display": "grid",
  "height": "100%",
  "gap": "0.5rem"
}, props => props.vertical ? 'column' : 'row', props => props.vertical ? 'fit-content' : '100%', props => `repeat(${props.radioCount}, 1fr)`, {
  "borderWidth": "2px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(62 126 254 / var(--tw-border-opacity, 1))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(245 249 255 / var(--tw-bg-opacity, 1))",
  "fontSize": "0.875rem",
  "lineHeight": "1rem",
  "fontWeight": "700",
  "--tw-text-opacity": "1 !important",
  "color": "rgb(62 126 254 / var(--tw-text-opacity, 1)) !important"
}, {
  "borderWidth": "2px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(62 126 254 / var(--tw-border-opacity, 1))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(245 249 255 / var(--tw-bg-opacity, 1))",
  "fontSize": "0.875rem",
  "lineHeight": "1rem",
  "fontWeight": "700",
  "--tw-text-opacity": "1 !important",
  "color": "rgb(62 126 254 / var(--tw-text-opacity, 1)) !important"
}, {
  "cursor": "default"
}, {
  "display": "flex",
  "height": "100%",
  "width": "100%",
  "cursor": "pointer",
  "alignItems": "center",
  "justifyContent": "center",
  "borderWidth": "1px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(206 213 220 / var(--tw-border-opacity, 1))",
  "fontSize": "0.875rem",
  "lineHeight": "1rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(105 117 134 / var(--tw-text-opacity, 1))"
}, {
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "gap": "0.75rem"
}, {
  "display": "flex",
  "width": "100%",
  "alignItems": "center",
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "500"
}, {
  "--tw-border-opacity": "1",
  "borderColor": "rgb(34 106 250 / var(--tw-border-opacity, 1))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(34 106 250 / var(--tw-bg-opacity, 1))",
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "700",
  "--tw-text-opacity": "1",
  "color": "rgb(245 249 255 / var(--tw-text-opacity, 1))"
}, {
  "display": "flex",
  "justifyContent": "flex-start"
}, props => props.customStyles?.wrap?.flexDirection ? props.customStyles.wrap.flexDirection : 'row', props => props.customStyles?.wrap?.gap ? props.customStyles.wrap.gap : '1rem', {
  "display": "flex",
  "alignItems": "center"
}, props => props.customStyles?.label?.flexGrow ? props.customStyles.label.flexGrow : '1', {
  "--tw-text-opacity": "1",
  "color": "rgb(25 32 41 / var(--tw-text-opacity, 1))"
}, {
  "cursor": "default",
  "--tw-text-opacity": "1",
  "color": "rgb(206 213 220 / var(--tw-text-opacity, 1))"
}, {
  "fontSize": "0.875rem",
  "lineHeight": "1rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(25 32 41 / var(--tw-text-opacity, 1))"
}, {
  "display": "grid",
  "height": "100%",
  "width": "100%",
  "gap": "0.5rem"
}, props => `repeat(${props.radioCount}, 1fr)`, {
  "borderWidth": "2px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(62 126 254 / var(--tw-border-opacity, 1))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(245 249 255 / var(--tw-bg-opacity, 1))",
  "fontSize": "0.875rem",
  "lineHeight": "1rem",
  "fontWeight": "700",
  "--tw-text-opacity": "1 !important",
  "color": "rgb(62 126 254 / var(--tw-text-opacity, 1)) !important"
}, {
  "borderWidth": "2px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(62 126 254 / var(--tw-border-opacity, 1))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(245 249 255 / var(--tw-bg-opacity, 1))",
  "fontSize": "0.875rem",
  "lineHeight": "1rem",
  "fontWeight": "700",
  "--tw-text-opacity": "1 !important",
  "color": "rgb(62 126 254 / var(--tw-text-opacity, 1)) !important"
}, {
  "cursor": "default"
}, {
  "display": "flex",
  "height": "100%",
  "width": "100%",
  "cursor": "pointer",
  "alignItems": "center",
  "justifyContent": "center",
  "borderWidth": "1px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(206 213 220 / var(--tw-border-opacity, 1))",
  "fontSize": "0.875rem",
  "lineHeight": "1rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(32 41 57 / var(--tw-text-opacity, 1))"
}, {
  "display": "grid",
  "height": "100%",
  "width": "100%",
  "gap": "0.5rem"
}, props => `repeat(${props.radioCount}, 1fr)`, {
  "borderWidth": "2px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(62 126 254 / var(--tw-border-opacity, 1))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(245 249 255 / var(--tw-bg-opacity, 1))",
  "fontSize": "0.875rem",
  "lineHeight": "1rem",
  "fontWeight": "700",
  "--tw-text-opacity": "1 !important",
  "color": "rgb(34 106 250 / var(--tw-text-opacity, 1)) !important"
}, {
  "borderWidth": "2px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(62 126 254 / var(--tw-border-opacity, 1))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(245 249 255 / var(--tw-bg-opacity, 1))",
  "fontSize": "0.875rem",
  "lineHeight": "1rem",
  "fontWeight": "700",
  "--tw-text-opacity": "1 !important",
  "color": "rgb(34 106 250 / var(--tw-text-opacity, 1)) !important"
}, {
  "cursor": "default"
}, {
  "display": "flex",
  "height": "100%",
  "minHeight": "6rem",
  "width": "100%",
  "cursor": "pointer",
  "flexDirection": "column",
  "alignItems": "center",
  "justifyContent": "center",
  "gap": "0.5rem",
  "whiteSpace": "pre-wrap",
  "borderWidth": "1px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(206 213 220 / var(--tw-border-opacity, 1))",
  "padding": "0.25rem",
  "textAlign": "center",
  "fontSize": "0.875rem",
  "lineHeight": "1rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(105 117 134 / var(--tw-text-opacity, 1))"
});
export const FormDatePickerStyle = styled.div.withConfig({
  componentId: "sc-e8u0ic-1"
})(["&{.datepicker-calendar-container{height:350px;background:transparent;right:50% !important;transform:translateX(50%) !important;}", " div div.react-datepicker-wrapper input{", " box-sizing:border-box;}div div.react-datepicker-wrapper input::placeholder{", "}div:first-child div.react-datepicker-wrapper input{border:", ";}div:nth-child(3) div.react-datepicker-wrapper input{border:", ";}div.react-datepicker-wrapper{width:100%;box-sizing:border-box;input{width:100%;border-radius:0.5rem;:focus{outline:2px solid var(--blue-50);border-color:transparent !important;}}svg{position:absolute;right:10px;top:50%;transform:translate(0,-50%);}}div.react-datepicker{", " box-shadow:0px 8px 24px 0px rgba(25,32,41,0.16);div.react-datepicker__triangle{display:none;}> span.react-datepicker__aria-live{display:none;}button.react-datepicker__navigation{", "}button.react-datepicker__navigation--previous{", "}button.react-datepicker__navigation--next{", "}div.react-datepicker__month-container{", " div.react-datepicker__header{", " div.react-datepicker__current-month{", "}div.react-datepicker__day-names{", " div{", "}}}div.react-datepicker__month{", " div.react-datepicker__week:first-child{gap:0;}div.react-datepicker__week{", " div{", "}.react-datepicker__day:not(.react-datepicker__day--range-start,.react-datepicker__day--in-range,.react-datepicker__day--selecting-range-end,.react-datepicker__day--selected):hover{", "}div:not(.react-datepicker__day--disabled,.react-datepicker__day--range-start,.react-datepicker__day--selected):hover::after{content:'';", " transform:translate(-50%,0);", "}div.react-datepicker__day:not(.react-datepicker__day--disabled){", "}div.react-datepicker__day--disabled{", "}div.react-datepicker__day--selected{", "}div.react-datepicker__day--selected.react-datepicker__day--today{", "}div.react-datepicker__day--today:not(.react-datepicker__day--selecting-range-start,.react-datepicker__day--range-start,.react-datepicker__day--selecting-range-start:hover,.react-datepicker__day--range-start:hover,[class*='react-datepicker__day--in-range'],[class*='react-datepicker__day--in-selecting-range']){", "}[class*='day--keyboard-selected']{", "}[class*='react-datepicker__day--in-range'],[class*='react-datepicker__day--in-selecting-range'],[class*='react-datepicker__day--in-range']:hover,[class*='react-datepicker__day--in-selecting-range']:hover{", "}div.react-datepicker__day--selecting-range-start,div.react-datepicker__day--range-start,div.react-datepicker__day--selecting-range-start:hover,div.react-datepicker__day--range-start:hover{", " background:linear-gradient( to right,transparent 0%,transparent 50%,var(--gray-90) 50%,var(--gray-90) 100% );}div.react-datepicker__day--selecting-range-end:not(.react-datepicker__day--selected),div.react-datepicker__day--range-end,div.react-datepicker__day--selecting-range-end:hover:not(.react-datepicker__day--selected),div.react-datepicker__day--range-end:hover{", "}div.react-datepicker__day--selecting-range-start::after,div.react-datepicker__day--range-start::after{content:'", "';}div.react-datepicker__day--selecting-range-end::before,div.react-datepicker__day--range-end::before{content:'", "';}div.react-datepicker__day--selecting-range-start::after,div.react-datepicker__day--range-start::after,div.react-datepicker__day--selecting-range-end::before,div.react-datepicker__day--range-end::before{", " transform:translate(-50%,0);}div.react-datepicker__day--selecting-range-start::after,div.react-datepicker__day--range-start::after,div.react-datepicker__day--range-end::before{", "}div.react-datepicker__day--selecting-range-end::before{", "}[aria-label*='\uC77C\uC694\uC77C']{", "}[aria-label*='\uD1A0\uC694\uC77C']{", "}div.react-datepicker__day--outside-month{opacity:0;}div.react-datepicker__day--range-start.react-datepicker__day--range-start{background-color:white;}}}}}}"], {
  "position": "relative",
  "display": "flex",
  "width": "100%",
  "alignItems": "center",
  "gap": "0.25rem"
}, {
  "height": "3rem",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(25 32 41 / var(--tw-text-opacity, 1))"
}, {
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(154 164 178 / var(--tw-text-opacity, 1))"
}, props => props.focusInput === 'start' ? '2px solid var(--blue-50)' : '1px solid var(--gray-70)', props => props.focusInput === 'end' ? '2px solid var(--blue-50)' : '1px solid var(--gray-70)', {
  "zIndex": "1",
  "width": "100%",
  "maxWidth": "20.5rem",
  "borderRadius": "0.75rem",
  "borderWidth": "1px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(206 213 220 / var(--tw-border-opacity, 1))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity, 1))",
  "padding": "1rem"
}, {
  "top": "1.25rem"
}, {
  "left": "1.25rem"
}, {
  "right": "1.25rem"
}, {
  "width": "100%"
}, {
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "borderStyle": "none",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity, 1))",
  "padding": "0px"
}, {
  "marginBottom": "1rem"
}, {
  "display": "flex",
  "width": "100%",
  "justifyContent": "space-between"
}, {
  "margin": "0px",
  "display": "flex",
  "height": "2.5rem",
  "width": "100%",
  "alignItems": "center",
  "justifyContent": "center",
  "fontSize": "0.8125rem",
  "lineHeight": "1rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(54 65 82 / var(--tw-text-opacity, 1))"
}, {
  "margin": "0px",
  "display": "flex",
  "flexDirection": "column",
  "gap": "0.13rem",
  "paddingTop": "0.5rem"
}, {
  "margin": "0px",
  "display": "flex",
  "justifyContent": "space-between"
}, {
  "position": "relative",
  "margin": "0px",
  "display": "flex",
  "height": "2.5rem",
  "width": "2.5rem",
  "alignItems": "center",
  "justifyContent": "center",
  "padding": "0.25rem",
  "fontSize": "0.8125rem",
  "lineHeight": "1rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(54 65 82 / var(--tw-text-opacity, 1))"
}, {
  "backgroundColor": "transparent"
}, {
  "position": "absolute",
  "left": "50%",
  "top": "0px",
  "display": "flex",
  "height": "2.5rem",
  "width": "2.5rem",
  "alignItems": "center",
  "justifyContent": "center",
  "borderRadius": "1.25rem"
}, {
  "borderWidth": "1px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(34 106 250 / var(--tw-border-opacity, 1))"
}, {
  "cursor": "pointer"
}, {
  "--tw-text-opacity": "1",
  "color": "rgb(206 213 220 / var(--tw-text-opacity, 1))"
}, {
  "display": "flex",
  "height": "2.5rem",
  "width": "2.5rem",
  "alignItems": "center",
  "justifyContent": "center",
  "borderRadius": "1.25rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(34 106 250 / var(--tw-bg-opacity, 1))",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity, 1))"
}, {
  "--tw-text-opacity": "1 !important",
  "color": "rgb(255 255 255 / var(--tw-text-opacity, 1)) !important"
}, {
  "fontSize": "0.8125rem",
  "lineHeight": "1rem",
  "fontWeight": "700",
  "--tw-text-opacity": "1",
  "color": "rgb(0 0 0 / var(--tw-text-opacity, 1))"
}, {
  "backgroundColor": "transparent",
  "fontSize": "0.8125rem",
  "lineHeight": "1rem",
  "fontWeight": "700",
  "--tw-text-opacity": "1",
  "color": "rgb(25 32 41 / var(--tw-text-opacity, 1))"
}, {
  "borderRadius": "0",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(238 242 246 / var(--tw-bg-opacity, 1))"
}, {
  "position": "relative",
  "borderTopLeftRadius": "1.25rem",
  "borderBottomLeftRadius": "1.25rem",
  "borderTopRightRadius": "0",
  "borderBottomRightRadius": "0"
}, {
  "position": "relative",
  "borderTopLeftRadius": "0",
  "borderBottomLeftRadius": "0",
  "borderTopRightRadius": "1.25rem",
  "borderBottomRightRadius": "1.25rem",
  "borderStyle": "none",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(238 242 246 / var(--tw-bg-opacity, 1))"
}, props => props.startDate, props => props.endDate, {
  "position": "absolute",
  "left": "50%",
  "top": "0px",
  "display": "flex",
  "height": "2.5rem",
  "width": "2.5rem",
  "alignItems": "center",
  "justifyContent": "center",
  "borderRadius": "1.25rem"
}, {
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(34 106 250 / var(--tw-bg-opacity, 1))",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity, 1))"
}, {
  "borderWidth": "1px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(34 106 250 / var(--tw-border-opacity, 1))"
}, {
  "borderTopLeftRadius": "0.375rem",
  "borderBottomLeftRadius": "0.375rem"
}, {
  "borderTopRightRadius": "0.375rem",
  "borderBottomRightRadius": "0.375rem"
});
export const studentInfoFormSelectCustomStyle = {
  control: (base, state) => ({
    ...base,
    maxHeight: '4.875rem',
    overflow: 'auto',
    width: '100%',
    borderRadius: '0.5rem',
    padding: '0 0.75rem',
    gap: '0.25rem',
    minHeight: '2.5rem',
    fontSize: '0.875rem',
    fontWeight: '500',
    color: 'var(--gray-10)',
    borderColor: state.isFocused ? 'transparent' : 'var(--gray-70)',
    boxShadow: state.isFocused ? '0 0 0 2px var(--blue-50)' : 'none',
    '&:hover': {
      borderColor: ''
    },
    '&:focus': {
      borderColor: ''
    }
  }),
  placeholder: base => ({
    ...base,
    fontSize: '0.875rem',
    fontWeight: '500',
    color: 'var(--gray-60)'
  }),
  option: (base, state) => ({
    ...base,
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    width: '100%',
    padding: '0.62rem 1rem',
    backgroundColor: state.isSelected ? 'var(--gray-80)' : '',
    color: state.isSelected ? 'inherit' : '',
    cursor: 'pointer',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    '&:hover': {
      backgroundColor: 'var(--gray-90)'
    },
    '&:active': {
      backgroundColor: 'var(--gray-80)'
    },
    '> span': {
      flexGrow: 1,
      color: 'var(--gray-50)',
      fontFamily: 'Pretendard',
      fontSize: '0.75rem',
      fontStyle: 'normal',
      fontWeight: '500',
      lineHeight: '0.875rem',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    }
  }),
  container: base => ({
    ...base,
    borderRadius: '0.5rem',
    backgroundColor: 'var(--gray-100)',
    boxShadow: '0px 8px 24px 0px rgba(25, 32, 41, 0.16)',
    height: '40rem',
    width: '15rem'
  }),
  indicatorsContainer: base => ({
    ...base,
    height: '100%'
  }),
  menu: base => ({
    ...base,
    position: 'static',
    border: 'none',
    boxShadow: 'none',
    margin: '0'
  }),
  menuList: base => ({
    ...base,
    padding: '0',
    fontSize: '0.875rem',
    maxHeight: '36.5rem'
  }),
  valueContainer: base => ({
    ...base,
    padding: '0',
    '> div': {
      padding: '0',
      margin: '0'
    }
  })
};
export const FormInputStyle = styled.div.withConfig({
  componentId: "sc-e8u0ic-2"
})(["&{", " input{", " height:", ";", " ", " :focus{outline:2px solid var(--blue-50);border-color:transparent;}}div{", "}}"], {
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "gap": "0.25rem"
}, {
  "width": "100%",
  "borderRadius": "0.5rem",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "paddingTop": "0.75rem",
  "paddingBottom": "0.75rem",
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "500"
}, props => props.height ? props.height : '3rem', props => props.disabled ? {
  "--tw-border-opacity": "1",
  "borderColor": "rgb(227 232 239 / var(--tw-border-opacity, 1))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(248 250 252 / var(--tw-bg-opacity, 1))",
  "--tw-text-opacity": "1",
  "color": "rgb(105 117 134 / var(--tw-text-opacity, 1))"
} : {
  "--tw-border-opacity": "1",
  "borderColor": "rgb(206 213 220 / var(--tw-border-opacity, 1))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity, 1))"
}, props => props.hasError ? {
  "outlineStyle": "solid",
  "outlineWidth": "2px",
  "outlineColor": "#F64857"
} : {
  "borderWidth": "1px",
  "borderStyle": "solid"
}, {
  "paddingLeft": "0.75rem",
  "fontSize": "0.8125rem",
  "lineHeight": "1rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(246 72 87 / var(--tw-text-opacity, 1))"
});
export const FormPhoneInputStyle = styled.div.withConfig({
  componentId: "sc-e8u0ic-3"
})(["&{", " .error-message{", "}}"], {
  "position": "relative",
  "width": "100%"
}, {
  "paddingTop": "0.25rem",
  "fontSize": "0.75rem",
  "lineHeight": "0.875rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(246 72 87 / var(--tw-text-opacity, 1))"
});
export const FormTextArea = styled.textarea.withConfig({
  componentId: "sc-e8u0ic-4"
})(["&{", " ::placeholder{", "}:disabled{", "}:focus{outline:2px solid var(--blue-50);border-color:transparent !important;}}"], {
  "borderRadius": "0.5rem",
  "borderWidth": "1px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(206 213 220 / var(--tw-border-opacity, 1))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity, 1))",
  "padding": "1.5rem",
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(25 32 41 / var(--tw-text-opacity, 1))"
}, {
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(154 164 178 / var(--tw-text-opacity, 1))"
}, {
  "borderStyle": "none",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(248 250 252 / var(--tw-bg-opacity, 1))",
  "--tw-text-opacity": "1",
  "color": "rgb(25 32 41 / var(--tw-text-opacity, 1))"
});